module.exports = __webpack_public_path__ + "static/media/0520-a-l-en.57406aae.png";